import { useEffect } from 'react';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { listarParametrosApi } from '../api/ListarParametrosApi';
import { hasGestorSelecionado } from '../api/shared';
import type { ListarParametrosResponse } from '../types';

export function useListarParametros(
  relatorioId?: number | null,
  options?: Omit<UseQueryOptions<ListarParametrosResponse, Error>, 'queryKey' | 'queryFn'>
) {
  const { toast } = useToast();

  const query = useQuery<ListarParametrosResponse, Error>({
    queryKey: ['relatorios', 'parametros', relatorioId],
    queryFn: () => listarParametrosApi(relatorioId as number),
    staleTime: 5 * 60 * 1000,
    ...options,
    enabled: (options?.enabled ?? true) && hasGestorSelecionado() && Boolean(relatorioId),
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      variant: 'destructive',
      title: 'Erro ao carregar parâmetros',
      description: 'Não foi possível carregar os parâmetros do relatório.',
    });
  }, [query.error, toast]);

  return query;
}
